
export type SizeType = {
    mobileS: string;
    mobileM: string;
    mobileL: string;
    tailwindSm: string;
    tailwindMd: string;
    tailwindLg: string;
    laptopS: string;
    tailwindXl: string;
    laptopL: string;
    tailwindXxl: string;
    desktop: string;
}

export const size: SizeType = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tailwindSm: "640px",
    tailwindMd: "768px",
    laptopS: '995px',
    tailwindLg: "1024px",
    tailwindXl: "1280px",
    laptopL: '1440px',
    tailwindXxl: "1536px",
    desktop: '2560px',
}